import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'

import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'

import { connect } from 'react-redux'

import { handleSaveFlexOptionData } from '../actions/rfp'
import { currencies, depositOptions } from '../utils/_DATA'
import { getMonthSuffix } from '../utils/helpers'
import t from '../utils/lang'

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    minWidth: '300px',
    maxWidth: '400px',
  },
  formControl: {
    margin: '0 0 10px',
    width: '100%'
  },
  currencyFormControl: {
    marginTop: '-2px'
  },
  sectionTitle: {
    marginTop: '15px',
    marginBottom: '10px',
    fontSize: '17px',
    fontWeight: '500'
  },
  formHyphen: {
    textAlign: 'center',
    marginTop: '22px'
  },
  formSuffix: {
    marginLeft: '10px',
    marginTop: '33px'
  },
  box: {
    display: 'flex'
  }
});

class FlexOptionDataDialog extends Component {
  state = {
    rentFee: [],
    rentCurrencyId: '',
    setupFee: [],
    setupCurrencyId: '',
    parkingFee: '',
    parkingCurrencyId: '',
    exitFee: [],
    exitCurrencyId: '',
    workstations: '',
    depositId: '',
    comment: '',
  }

  componentDidMount() {
    const { data, rfpId, index } = this.props
    const option = data && data.options[index]
    //console.log('Option', option)

    option && this.setState(() => ({
      rentFee: (!option.rentFee || !option.rentFee.length)
        ? [null, null, null]
        : [null, null, null].map((el, i) => option.rentFee[i]),
      rentCurrencyId: option.rentCurrencyId !== null ? option.rentCurrencyId : '',
      setupFee: option.setupFee,
      setupCurrencyId: option.setupCurrencyId !== null ? option.setupCurrencyId : '',
      parkingFee: option.parkingFee,
      parkingCurrencyId: option.parkingCurrencyId !== null ? option.parkingCurrencyId : '',
      exitFee: (!option.exitFee || !option.exitFee.length)
        ? [null, null, null]
        : [null, null, null].map((el, i) => option.exitFee[i]),
      exitCurrencyId: option.exitCurrencyId !== null ? option.exitCurrencyId : '',
      workstations: option.workstations !== null ? option.workstations : '',
      depositId: option.depositId !== null ? option.depositId : '',
      comment: option.comment !== null ? option.comment : '',
    }))
  }

  handleChangeRentFee = key => e => {
    const rentFeeValue = e.target.value
    const { rentFee } = this.state
    rentFee[key] = rentFeeValue == "" ? null : Number(rentFeeValue)

    this.setState(() => ({
      rentFee
    }))
  }

  handleChangeRentCurrencyId = e => {
    const rentCurrencyId = e.target.value

    this.setState(() => ({
      rentCurrencyId
    }))
  }

  handleChangeSetupFee = e => {
    const setupFeeValue = e.target.value

    this.setState(() => ({
      setupFee: setupFeeValue == "" ? null : Number(setupFeeValue)
    }))
  }

  handleChangeSetupCurrencyId = e => {
    const setupCurrencyId = e.target.value

    this.setState(() => ({
      setupCurrencyId
    }))
  }

  handleChangeParkingFee = e => {
    const parkingFee = e.target.value

    this.setState(() => ({
      parkingFee
    }))
  }

  handleChangeParkingCurrencyId = e => {
    const parkingCurrencyId = e.target.value

    this.setState(() => ({
      parkingCurrencyId
    }))
  }

  handleChangeExitFee = key => e => {
    const exitFeeValue = e.target.value
    const { exitFee } = this.state
    exitFee[key] = exitFeeValue == "" ? null : Number(exitFeeValue)

    this.setState(() => ({
      exitFee
    }))
  }

  handleChangeExitCurrencyId = e => {
    const exitCurrencyId = e.target.value

    this.setState(() => ({
      exitCurrencyId
    }))
  }

  handleChangeWorkstations = e => {
    const workstations = e.target.value

    this.setState(() => ({
      workstations
    }))
  }

  handleChangeDepositId = e => {
    const depositId = e.target.value

    this.setState(() => ({
      depositId
    }))
  }

  handleChangeComment = e => {
    const comment = e.target.value

    this.setState(() => ({
      comment
    }))
  }

  handleSaveData = e => {
    const { rfpId, index, handleClose, dispatch } = this.props
    const data = JSON.stringify(this.state)

    //console.log('handleSaveData', index, data)

    dispatch(handleSaveFlexOptionData(rfpId, index, data))

    handleClose()
  }

  render() {
    const { fullScreen, open, handleClose, classes, lang, leasePeriods } = this.props
    const {
      rentFee, rentCurrencyId,
      setupFee, setupCurrencyId,
      parkingFee, parkingCurrencyId,
      exitFee, exitCurrencyId,
      workstations, depositId, comment
    } = this.state

    const feeContainers = leasePeriods.length || 1;

    return (
      <div>
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">{t[lang].editOption}</DialogTitle>
          <DialogContent>
            <form className={classes.root}>

              <Grid container>
                <Grid item xs={9}>
                  <FormControl className={classes.formControl}>
                    <TextField
                      id="setupFee"
                      label={t[lang].setupFee}
                      type="number"
                      inputProps={{ step: "0.01" }}
                      value={setupFee}
                      onChange={this.handleChangeSetupFee}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={1} />
                <Grid item xs={2}>
                  <InputLabel htmlFor="setupCurrencyId">{t[lang].currency}</InputLabel>
                  <Select
                    id="setupCurrencyId"
                    value={setupCurrencyId}
                    onChange={this.handleChangeSetupCurrencyId}
                    className={classes.currencyFormControl}
                  >
                    {currencies.map((option) => (
                      <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                    ))}
                  </Select>
                </Grid>
              </Grid>

              <Typography variant="headline" className={classes.sectionTitle}>
                {t[lang].monthlyRentFee}
              </Typography>

              <Grid container>

                <Grid item xs={9}>
                  <div className={classes.box}>
                    {rentFee && Array(feeContainers).fill(null).map((el, key) =>
                      <FormControl className={classes.formControl}>
                        <TextField
                          id={"rentFee" + (key + 1)}
                          label={leasePeriods[key] ? leasePeriods[key].value + ' ' + getMonthSuffix(leasePeriods[key].value, lang) : ''}
                          type="number"
                          inputProps={{ step: "0.01" }}
                          value={rentFee[key]}
                          onChange={this.handleChangeRentFee(key)}
                        />
                      </FormControl>
                    )}
                  </div>
                </Grid>
                <Grid item xs={1} />
                <Grid item xs={2}>
                  <InputLabel htmlFor="rentCurrencyId">{t[lang].currency}</InputLabel>
                  <Select
                    id="rentCurrencyId"
                    value={rentCurrencyId}
                    onChange={this.handleChangeRentCurrencyId}
                    className={classes.currencyFormControl}
                  >
                    {currencies.map((option) => (
                      <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                    ))}
                  </Select>
                </Grid>
              </Grid>

              <Typography variant="headline" className={classes.sectionTitle}>
                {t[lang].exitFee}
              </Typography>

              <Grid container>
                <Grid item xs={9}>
                  <div className={classes.box}>
                    {exitFee && Array(feeContainers).fill(null).map((el, key) =>
                      <FormControl className={classes.formControl}>
                        <TextField
                          id={"exitFee" + (key + 1)}
                          label={leasePeriods[key] ? leasePeriods[key].value + ' ' + getMonthSuffix(leasePeriods[key].value, lang) : ''}
                          type="number"
                          inputProps={{ step: "0.01" }}
                          value={exitFee[key]}
                          onChange={this.handleChangeExitFee(key)}
                        />
                      </FormControl>
                    )}
                  </div>
                </Grid>
                <Grid item xs={1} />
                <Grid item xs={2}>
                  <InputLabel htmlFor="exitCurrencyId">{t[lang].currency}</InputLabel>
                  <Select
                    id="exitCurrencyId"
                    value={exitCurrencyId}
                    onChange={this.handleChangeExitCurrencyId}
                    className={classes.currencyFormControl}
                  >
                    {currencies.map((option) => (
                      <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                    ))}
                  </Select>
                </Grid>
              </Grid>

              <Grid container>
                <Grid item xs={9}>
                  <FormControl className={classes.formControl}>
                    <TextField
                      id="parkingFee"
                      label={t[lang].parkingFee}
                      type="number"
                      inputProps={{ step: "0.01" }}
                      value={parkingFee}
                      onChange={this.handleChangeParkingFee}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={1} />
                <Grid item xs={2}>
                  <InputLabel htmlFor="parkingCurrencyId">{t[lang].currency}</InputLabel>
                  <Select
                    id="parkingCurrencyId"
                    value={parkingCurrencyId}
                    onChange={this.handleChangeParkingCurrencyId}
                    className={classes.currencyFormControl}
                  >
                    {currencies.map((option) => (
                      <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                    ))}
                  </Select>
                </Grid>
              </Grid>

              <FormControl className={classes.formControl}>
                <TextField
                  id="workstations"
                  label={t[lang].numberOfWorkstations}
                  value={workstations}
                  type="number"
                  onChange={this.handleChangeWorkstations}
                />
              </FormControl>

              <FormControl className={classes.formControl}>
                {/*<TextField
                  id="depositId"
                  label={t[lang].deposit}
                  select
                  value={depositId}
                  onChange={this.handleChangeDepositId}
                  //className={classes.statusInput}
                  //disabled={proposalSubmitted}
                  margin="normal"
                >
                  {depositOptions[lang].map(option => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>*/}

                <InputLabel htmlFor="depositId">{t[lang].deposit}</InputLabel>
                <Select
                  id="depositId"
                  value={depositId}
                  onChange={this.handleChangeDepositId}
                  name="depositId"
                //margin="normal"
                >
                  {depositOptions[lang].map(option => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl className={classes.formControl}>
                <TextField
                  id="comment"
                  label={t[lang].comment}
                  value={comment}
                  multiline
                  onChange={this.handleChangeComment}
                />
              </FormControl>
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              {t[lang].cancel}
            </Button>
            <Button onClick={this.handleSaveData} color="primary" autoFocus>
              {t[lang].save}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

FlexOptionDataDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

function mapStateToProps({ rfpData }) {
  const { lang, id, flexData, leasePeriods } = rfpData

  return {
    lang,
    rfpId: id,
    leasePeriods,
    data: JSON.parse(flexData.form)
  }
}

export default connect(mapStateToProps)(withStyles(styles)(withMobileDialog()(FlexOptionDataDialog)))


// WEBPACK FOOTER //
// ./src/components/FlexOptionDataDialog.js